import React from 'react'
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ReactGA from "react-ga";
function UseGaTracker(){
    const location = useLocation();
    const [initialized, setInitialized] = useState(false);
    const [step,setStep] = useState(useParams())
    // useEffect(() => {
    //     if (!window.location.href.includes(`https://passportdocpros.com/Apply/#/start/${step.step}`)) {
    //         ReactGA.initialize("UA-201608881-2")
    //     }
    //     setInitialized(true);
    // }, []);

    useEffect(() => {
            ReactGA.initialize("UA-180163761-9")

        ReactGA.pageview(location.pathname + location.search);
    }, [initialized, location]);
};

export default UseGaTracker;